import React, { FC, useContext } from 'react';
import { UserContext } from '../../../../user/UserContext';
import { useRestrictedModal } from '../../../../components/modal/useRestrictedModal';
import { Hyperlink } from '../../../../components/Hyperlink';
import styles from './entity_list_link_title.module.scss';

type Props = {
  entityId: string;
  entityUrl: string;
  entityName: string;
  source: string;
};

export const EntityListLinkTitle: FC<Props> = ({
  entityId,
  entityName,
  entityUrl,
  source,
}) => {
  const { accessPremium } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();
  const props = accessPremium
    ? {
        href: entityUrl,
        source,
      }
    : {
        onClick: () => openRestrictedModal({ source }),
      };
  return (
    <Hyperlink
      className={styles.title}
      data-doctrine-popover
      data-lawyer={entityId}
      {...props}
    >
      {entityName}
    </Hyperlink>
  );
};
